import {Column, Entity, Index, JoinColumn, ManyToOne, OneToMany, PrimaryColumn} from "typeorm";
import {Point} from "entities/Point";
import {User} from "entities/User";
import {Exclude} from "class-transformer";

@Entity()
@Index("navigation_idx", ["dS", "usr", "tp"])
export class Navigation {
  @PrimaryColumn({type: "varchar"})
  @Index()
  ID: string;

  @Column({nullable: true, name: "aE", type: "varchar"})
  aE: string | null;

  @Column({nullable: true, name: "aS", type: "varchar"})
  aS: string | null;

  @Column({type: "varchar", nullable: true, name: "brg"})
  brg: string | null;

  @Column({type: "int", nullable: true, name: "bs5"})
  bs5: number | null;

  @Column({nullable: true, name: "ci", type: "varchar"})
  ci: string | null;

  @Column({nullable: true, name: "co", type: "varchar"})
  co: string | null;

  @Column({type: "float", nullable: true, name: "dS"})
  @Index()
  dS: number | null;

  @Column({nullable: true, name: "dSE", type: "varchar"})
  dSE: string | null;

  @Column({type: "float", nullable: true, name: "dT"})
  dT: number | null;

  @Column({type: "float", nullable: true, name: "dTL"})
  dTL: number | null;

  @Column({nullable: true, name: "dsc", type: "varchar"})
  dsc: string | null;

  @Column({nullable: true, name: "eq", type: "varchar"})
  eq: string | null;

  @Column({nullable: true, name: "eq2", type: "varchar"})
  eq2: string | null;

  @Column({nullable: true, name: "eq3", type: "varchar"})
  eq3: string | null;

  @Column({type: "int", nullable: true, name: "fe"})
  fe: number | null;

  @Column({nullable: true, name: "fnt", type: "varchar"})
  fnt: string | null;

  @Column({nullable: true, name: "fntM", type: "varchar"})
  fntM: string | null;

  @Column({nullable: true, name: "devM", type: "varchar"})
  devM: string | null;

  @Column({default: false, name: "isDel", type: "boolean"})
  isDel: boolean;

  @Column({type: "float", nullable: true, name: "lg"})
  lg: number | null;

  @Column({type: "bigint", nullable: true, name: "lmd"})
  lmd: string | null;

  @Column({type: "float", nullable: true, name: "lt"})
  lt: number | null;

  @Column({nullable: true, name: "nm", type: "varchar"})
  nm: string | null;

  @Column({type: "float", nullable: true, name: "ps"})
  ps: number | null;

  @Column({type: "float", nullable: true, name: "sA"})
  sA: number | null;

  @Column({type: "float", nullable: true, name: "sM"})
  sM: number | null;

  @Column({type: "float", nullable: true, name: "sT"})
  sT: number | null;

  @Column({type: "float", nullable: true, name: "sort"})
  sort: number | null;

  @Column({type: "int", nullable: true, name: "str"})
  str: number | null;

  @Column({default: true, name: "sv", type: "boolean"})
  sv: boolean;

  @Column({type: "float", nullable: true, name: "tck"})
  tck: number | null;

  @Column({type: "int", nullable: true, name: "tp"})
  @Index()
  tp: number | null;

  @Column({type: "float", nullable: true, name: "tt"})
  tt: number | null;

  @Column({nullable: true, name: "usr", type: "varchar"})
  @Index()
  usr: string | null;

  @Column({type: "float", nullable: true, name: "wA"})
  wA: number | null;

  @Column({nullable: true, name: "wD", type: "varchar"})
  wD: string | null;

  @Column({type: "float", nullable: true, name: "wS"})
  wS: number | null;

  @Column({nullable: true, name: "Grp", type: "varchar"})
  Grp: string | null;

  @Column({nullable: true, name: "Prvy", type: "varchar"})
  Prvy: string | null;

  @Column({nullable: true, name: "WID", type: "varchar"})
  WID: string | null;

  @Column({nullable: true, name: "idF", type: "varchar"})
  idF: string | null;

  @Column({nullable: true, name: "wtr", type: "varchar"})
  wtr: string | null;

  // Set by the Strava auto-upload (Cloud Functions). Mirrored locally only so cloud sync, which
  // overwrites the whole remote Nav node with this row, doesn't wipe it and cause a second upload.
  @Column({type: "float", nullable: true, name: "stU"})
  stU: number | null;

  @Exclude()
  @OneToMany(() => Point, (point) => point.navigation, {cascade: true})
  points: Point[];

  @Exclude()
  @ManyToOne(() => User, (user) => user.navigations)
  @JoinColumn({name: "usr", referencedColumnName: "ID"})
  user: User;
}
